import {find} from '../helpers';

const element = find('[data-segment-block]');

if (element) {
    import('./segments');
}
